const appConfig = {
  "name": "account-registration",
  "version": "1.0.0",
  "stage": "master",
  "regions": [
    {
      "name": "us-east-1",
      "isPrimaryRegion": true,
      "deployThisBuild": true,
      "regionDomain": "get.atlas-config.mit.edu",
      "amplify": {
        "userPoolId": "us-east-1_bCu6BU8d2",
        "userPoolWebClientId": "15pldck9mb0bgim643vn49b64s",
        "oauth": {
          "domain": "atlas-auth.mit.edu",
          "scope": [
            "profile",
            "openid",
            "digital-id/user"
          ],
          "redirectSignIn": "https://account-registration.mit.edu",
          "redirectSignOut": "https://account-registration.mit.edu/logout",
          "responseType": "token",
          "options": {
            "AdvancedSecurityDataCollectionFlag": false
          }
        }
      },
      "signInProvider": "Touchstone",
      "api": {
        "domain": "api.mit.edu",
        "paths": {
          "account": "account-v1",
          "digital-id": "digital-id-v1"
        }
      }
    },
    {
      "name": "us-west-1",
      "isPrimaryRegion": false,
      "deployThisBuild": true,
      "regionDomain": "get.atlas-config.mit.edu",
      "amplify": {
        "userPoolId": "us-west-1_zsHXbydwR",
        "userPoolWebClientId": "5geio5v8i0osrs617a14dqiae7",
        "oauth": {
          "domain": "atlas-auth-us-west.mit.edu",
          "scope": [
            "profile",
            "openid",
            "digital-id/user"
          ],
          "redirectSignIn": "https://account-registration.mit.edu",
          "redirectSignOut": "https://account-registration.mit.edu/logout",
          "responseType": "token",
          "options": {
            "AdvancedSecurityDataCollectionFlag": false
          }
        }
      },
      "signInProvider": "Touchstone",
      "api": {
        "domain": "api-us-west.mit.edu",
        "paths": {
          "account": "account-v1",
          "digital-id": "digital-id-v1"
        }
      }
    }
  ]
};
export default appConfig;